import React, { useState } from "react"
import styles from "./Blank.module.scss"
import logo from "./logo-square.png"
import WIP from "../WIP/WIP"
import Tasks from "../../Tasks/Tasks"
import Wikis from "../../Wikis/Wikis"
import { UserInterface } from "../../../App"
import MessageBar from "../../MessageBar/MessageBar"
import { ChatModeInterface } from "../../Home/Home"

interface BlankProps {
    newSession: any
    user: UserInterface
    setUser: any
    chatMode: string
    setChatMode: React.Dispatch<React.SetStateAction<ChatModeInterface["chatMode"]>>
}

const Blank: React.FC<BlankProps> = ({ newSession, user, setUser, chatMode, setChatMode }) => {
    const [input, setInput] = useState<string>("")

    return (
        <>
            <div className={styles.root}>
                <div className={styles.container}>
                    <div className={styles.logoContainer}>
                        <img src={logo} alt={"Pretzel Logo"} className={styles.logo} />
                        <h1>Pretzel</h1>
                    </div>
                    <div className={styles.gridContainer}>
                        <div className={styles.gridItem}>
                            <div className={styles.sections}>
                                <span className="material-symbols-rounded">folder_shared</span>
                                <br />
                                Get started
                            </div>
                        </div>
                        <div className={styles.gridItem}>
                            <div className={styles.sections}>
                                <span className="material-symbols-rounded">clear_all</span>
                                <br />
                                Quick AI commands
                            </div>
                        </div>
                        <div className={styles.gridItem}>
                            <div className={styles.sections}>
                                <span className="material-symbols-rounded">groups</span>
                                <br />
                                Team apps
                            </div>
                        </div>
                        <div className={styles.gridItem}>
                            <div
                                onClick={() => {
                                    newSession({
                                        view: "chat",
                                        send: "files",
                                    })
                                }}
                                className={styles.demo}>
                                List Files
                            </div>
                            <div
                                onClick={() => {
                                    newSession({
                                        view: "chat",
                                        send: "files",
                                        createFile: "doc",
                                    })
                                }}
                                className={styles.demo}>
                                Create a doc
                            </div>
                            <div
                                onClick={() => {
                                    newSession({
                                        view: "chat",
                                        send: "files",
                                        createFile: "sheet",
                                    })
                                }}
                                className={styles.demo}>
                                Create a sheet
                            </div>
                            <div
                                onClick={() => {
                                    newSession({ view: "chat", send: "files" })
                                }}
                                className={styles.demo}>
                                Create a DB
                            </div>
                        </div>
                        <div className={styles.gridItem}>
                            <div
                                onClick={() => {
                                    newSession({
                                        view: "chat",
                                        send: "find images on french revolution",
                                    })
                                }}
                                className={styles.demo}>
                                Find images on French Revolution
                            </div>
                            <div
                                onClick={() => {
                                    newSession({
                                        view: "chat",
                                        send: "flashcards",
                                    })
                                }}
                                className={styles.demo}>
                                Flash cards
                            </div>
                            <div
                                onClick={() => {
                                    newSession({
                                        view: "chat",
                                        send: "plot 2014 sales",
                                    })
                                }}
                                className={styles.demo}>
                                Plot 2014 sales
                            </div>
                            <div
                                onClick={() => {
                                    newSession({
                                        view: "chat",
                                        send: "glossary",
                                    })
                                }}
                                className={styles.demo}>
                                Glossary
                            </div>
                        </div>

                        <div className={styles.gridItem}>
                            <div
                                onClick={() => {
                                    newSession({
                                        component: <Tasks user={user} setUser={setUser} />,
                                    })
                                }}
                                className={styles.demo}>
                                Tasks
                            </div>
                            <div className={styles.demo}>Wikis</div>
                            <div
                                onClick={() => {
                                    newSession({ view: "chat" })
                                }}
                                className={styles.demo}>
                                Message
                            </div>
                            <div
                                onClick={() => {
                                    newSession({ component: <WIP /> })
                                }}
                                className={styles.demo}>
                                Email
                            </div>
                        </div>
                    </div>

                    <div style={{ width: "100%", padding: "1rem 3rem" }}>
                        <MessageBar
                            input={input}
                            setInput={setInput}
                            disabled={false}
                            chatMode={chatMode}
                            setChatMode={setChatMode}
                            callback={(input: string) => {
                                newSession({ view: "chat", send: input })
                            }}
                        />
                    </div>

                    <br />
                    <br />
                </div>
            </div>
        </>
    )
}

export default Blank
